// El texto de los 10 avisos del equipo bloqueado. Copia literal del `MDM_NOTICE_TEXTS` de
// trustonic-connector (`src/components/constants/mdmNoticeTexts.ts`): si allá cambia, aquí también.
import type { MdmNoticeType } from './types';

/** El aviso tal como lo lee el cliente en la pantalla de su equipo bloqueado. */
export interface MdmNoticeText {
    title: string;
    content: string;
}

export const MDM_NOTICE_TEXTS: Record<MdmNoticeType, MdmNoticeText> = {
    PRE_DUE_2_DAYS: {
        title: 'Tu pago vence en 2 días',
        content:
            'Tu próxima cuota vence en 2 días. Realiza tu pago a tiempo para que tu equipo siga funcionando.',
    },
    PRE_DUE_1_DAY: {
        title: 'Tu pago vence mañana',
        content: 'Tu cuota vence mañana. Realiza tu pago para evitar que tu equipo se bloquee.',
    },
    DUE_TODAY: {
        title: 'Tu pago vence hoy',
        content: 'Hoy es el último día para pagar tu cuota. Si no pagas, tu equipo se bloquea.',
    },
    OVERDUE_1_DAY: {
        title: 'Tu equipo está bloqueado',
        content:
            'Tu cuota venció y tu equipo quedó bloqueado. Ponte al corriente para desbloquearlo.',
    },
    OVERDUE_3_DAYS: {
        title: 'Tu cuota sigue vencida',
        content:
            'Han pasado 3 días desde el vencimiento de tu cuota. Ponte al corriente para recuperar tu equipo.',
    },
    OVERDUE_7_DAYS: {
        title: 'Llevas una semana de atraso',
        content:
            'Tu cuota lleva 7 días vencida. Acércate a tu tienda o ponte al corriente para recuperar tu equipo.',
    },
    OVERDUE_14_DAYS: {
        title: 'Tu crédito lleva 14 días de atraso',
        content:
            'Puedes pagar en cualquier momento o acercarte a tu tienda para regularizar tu crédito.',
    },
    OVERDUE_25_DAYS: {
        title: 'Tu atraso ya lleva 25 días',
        content:
            'Tu equipo sigue bloqueado y tu adeudo sigue creciendo. Acércate a tu tienda para resolverlo.',
    },
    OVERDUE_30_DAYS: {
        title: 'Un mes de atraso en tu crédito',
        content:
            'Tu crédito lleva 30 días vencido. Ponerte al corriente es la única forma de recuperar tu equipo.',
    },
    OVERDUE_60_DAYS: {
        title: 'Último aviso automático',
        content:
            'Tu crédito lleva 60 días de atraso y este es el último aviso que recibirás en tu equipo. Comunícate con tu tienda.',
    },
};
